abstract class Filter {
    protected value: string[] = []

    type: 'all' | 'some' | 'one' | 'contains' = null
    onFilterChange: () => void = null

    async matches(post: PostItem, categories: string[]): Promise<boolean> {
        switch (this.type) {
            case 'contains':
                return categories.some((it) =>
                    it.toLowerCase().includes(this.value[0]),
                )
            case 'one':
                return (
                    this.value.length === 0 ||
                    categories.includes(this.value[0])
                )
            case 'some':
                return (
                    this.value.length === 0 ||
                    this.value.some((it) => categories.includes(it))
                )
            case 'all':
                return (
                    this.value.length === 0 ||
                    this.value.every((it) => categories.includes(it))
                )
        }
    }

    reset() {
        this.value = []
    }
}

export default Filter
